export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '申报记录';